<div class="app-card">
    <ng-content></ng-content>
</div>
